import { useTranslation } from 'react-i18next'
import { usePlatform } from '@/hooks'
import logo from '@/assets/logo.jpg'

export default function Footer() {
  const { t } = useTranslation()
  const platform = usePlatform()
  const isApp = platform === 'app'
  const year = new Date().getFullYear()

  return (
    <footer
      className="text-slate-300"
      style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #1e3a8a 100%)' }}
    >
      {isApp ? (
        <div className="py-8 pb-20 px-4 text-center">
          <div className="flex items-center justify-center space-x-2 mb-2">
            <img src={logo} alt={t('site.name')} className="w-10 h-10 rounded-lg object-contain shrink-0" />
            <span className="text-lg font-bold text-white">{t('site.name')}</span>
          </div>
          <p className="text-blue-200/70 text-xs leading-relaxed mb-4">
            {t('site.description')}
          </p>
          <p className="text-xs text-blue-200/70">
            &copy; {year} {t('site.name')}. All rights reserved.
          </p>
        </div>
      ) : (
        <div className="py-8 max-w-7xl mx-auto px-6 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center space-x-3">
            <img src={logo} alt={t('site.name')} className="w-12 h-12 rounded-lg object-contain shrink-0" />
            <div>
              <div className="text-base font-bold text-white">{t('site.name')}</div>
              <p className="text-blue-200/70 text-xs leading-relaxed max-w-md">
                {t('site.description')}
              </p>
            </div>
          </div>
          <p className="text-sm text-blue-200/70 md:text-right">
            &copy; {year} {t('site.name')}. All rights reserved.
          </p>
        </div>
      )}
    </footer>
  )
}
